<template>
	<div class="LaunchPage-container" v-if="container">
		<div class="content">
			<div class="title_box">
				<div class="img_box"><img class="loading" src="../../assets/loading.gif" /></div>
				<div class="text_box">{{ $t('loading') }} <div class="dotting"></div></div>
			</div>
		</div>
	</div>
</template>

<script>
  import router from "../../router"
  import { post_community_userinfo, post_community_login } from '@/api/community.js'
  // import { getInfo } from '@/api/user'
  // import { post_unilogin } from '@/api/user_center'

  // import rolesFun from "../../utils/roles"

	export default {
		name: "login",
		components: { },
		props: { },
	data () {
		return {
			container: true,
		}
	},
	watch: {
		 // $route: {
		 //   handler: function (route) {
		 //     const query = route.query
		 //     if (query) {
		 //       this.redirect = query.redirect
		 //       this.otherQuery = this.getOtherQuery(query)
		 //     }
		 //   },
		 //   immediate: true
		 // }
	},

	destroyed () {

	},

	created () {

   },
  
	mounted () {
		console.log(this.$route.query)
		if(this.$route.query.startUp){
			this.get_cookie_expired()
			// this.get_cssssookie()
		}else{
			this.go_user_center_login()
		}
	},

	methods: {
		// 重定向到登录中心
		go_user_center_login(){
			console.log(process.env.VUE_APP_API_URL_LOGIN)
			console.log(location.href)
			console.log(router.currentRoute.fullPath)
			console.log(this.$route.fullPath)
			let host = process.env.VUE_APP_API_URL_LOGIN
			let url = `${host}&locale=${this.$language}`
			window.location.href = url;
			// location.href = process.env.VUE_APP_BASE_UserCenterUrl + '/determine?businessUrl='+ process.env.VUE_APP_BASE_businessUrl +'&callback=' + this.$route.fullPath
			// window.open('http://192.168.0.99:9529/#/login ','_self')
		},
		
		// 获取 cookie 的函数是否过期
		get_cookie_expired() {
		   let decodedCookies = {};
		   let cookieValue = document.cookie;
		   if (cookieValue && cookieValue.length!== 0) {
		      cookieValue.split(';').forEach(cookie => {
		         let parts = cookie.split('=');
		         let key = decodeURIComponent(parts[0].trim()); 
		         let value = decodeURIComponent(parts[1]);
		         decodedCookies[key] = value;
		      });
				let that = this
				function refresh_fun(){
					// 检查 DIV_authentication 的过期时间
					// let divAuthExpires = that.checkExpiry('DIV_authentication', decodedCookies);
					let session_key = decodedCookies.DIV_authentication
					console.log(session_key)
					if (session_key) {
						let DIV_authentication_expire = decodedCookies.DIV_authentication_expire
						let refresh = true
						if(DIV_authentication_expire){
							const new_expire = DIV_authentication_expire;
							const currentTime = Math.floor(Date.now() / 1000); // 获取当前时间戳（秒）
							if (currentTime > new_expire) {
								refresh = false
								console.log("中心过期");
							} else {
								refresh = true
								console.log("中心期间");
							}
						}
						
						if(session_key && session_key != 'undefined' && session_key != '' && refresh){
						  that.post_community_login(session_key)
						}
					} else {
						// that.LoginTips()
						that.$cookie.delete('login_token') //社区接口的token
						that.$cookie.delete('login_token_expire') //社区接口的token 过期时间
						that.$cookie.delete('token') //官网接口的token
						that.$cookie.delete('DIV_authentication') //获取token的key
						that.$cookie.delete('DIV_authentication_expire') //获取token的过期时间
						that.$cookie.delete('user')
					   console.log('中心过期');
					}
				}
				
		      // 检查 社区token 的过期时间
		      let login_token = decodedCookies.login_token
		      let login_token_expire = decodedCookies.login_token_expire
				console.log(login_token);
				console.log(login_token_expire);
				if(login_token){
					console.log("应用没过期");
					this.$store.state.userinfo.login_token = login_token
					this.getInfo(login_token)
				}else if (login_token_expire) {
					const new_expire = login_token_expire - 3600; // 减去1小时（3600秒）
					const currentTime = Math.floor(Date.now() / 1000); // 获取当前时间戳（秒）
					if (currentTime > new_expire) {
						refresh_fun()
						console.log("应用即将过期");
					} else {
						refresh = false
						console.log("应用期间");
					}
		      } else {
					console.log("应用过期");
		         refresh_fun()
		      }
		   }
		},
		
		get_cookie(){
		  // let cookieValue = decodeURIComponent(document.cookie); //decodeURIComponent反转译
		  // let encodeURIComponent_ = encodeURIComponent(document.cookie); //decodeURIComponent转译
		  let decodedCookies = {};
		  let cookieValue = document.cookie;
		  if(cookieValue && cookieValue.length != 0){
		    cookieValue.split(';').forEach(cookie => {
		      let parts = cookie.split('=');
		      let key = decodeURIComponent(parts[0].trim()); //decodeURIComponent反转译
		      let value = decodeURIComponent(parts[1]);
		      decodedCookies[key] = value;
		    });
		    let session_key = decodedCookies.DIV_authentication
			 console.log(session_key)
		    if(session_key && session_key != 'undefined' && session_key != ''){
		      this.post_community_login(session_key)
		    }
		  }
		  
		},
		
		//登录
		post_community_login(session_key){
			if(this.Loading){ return }
			this.Loading = true
			post_community_login({session_key: session_key})
		   .then((res) => {
				console.log(res)
				this.Loading = false
				if(res.code == 0){
					let login_token = res.data.token
					let token_expire = res.data.token_expire
					// 使用 Math.floor() 和 Date.now() 方法获取当前时间戳（秒）
					let timestampInSeconds = Math.floor(Date.now() / 1000);
					let Expired = Number(timestampInSeconds)+Number(token_expire)
					this.$cookie.set('login_token', login_token, { expires: '7D' })
					this.$cookie.set('login_token_expire', Expired, { expires: '7D' })
					this.$store.state.userinfo.login_token = login_token
					this.getInfo(login_token)
				}else{
					this.exception_handling(res)
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err)
		   })
		},
		
		
		//获取用户信息
		getInfo(login_token){
			if(this.Loading){ return }
			post_community_userinfo()
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					let response = res.data
					response.login_way = 'local'
					response.login_token = login_token
					this.$cookie.set('user', JSON.stringify(response), { expires: '7D' })
					this.$store.dispatch('userinfo', [response, this])
					this.$store.commit('changeUserinfo', Object.assign({}, this.$store.state.userinfo, response))
					
					
					if(this.$route.query.redirect){
					  this.$router.push({ path: this.$route.query.redirect})
					}else{
					  this.$router.push({ name: "home"})
					}
				}else{
					this.exception_handling(res)
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err)
		   })
		},
		
		//异常处理
		exception_handling(err){
			this.Loading = false
			this.$errorMessage(err)
			// this.$message('err.data.message', 'error')
		},

	}
}
</script>

<style scoped>
	.LaunchPage-container {
		position: relative;
		min-height: 100%;
		width: 100%;
		box-sizing: border-box;
		min-height: 250px;
		padding: 10px;
		background-color: #ffffff;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.LaunchPage-container .content{
		width: 100%;
		height: 100%;
		max-width: 1500px;
		min-width: 1280px;
		margin: auto;
		text-align: center;
	}
	.title_box{
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	
	.text_box{
		margin-top: 20px;
		display: flex;
		line-height: 1;
		align-items: center;
		font-size: 14px;
		color: #999999;
		font-weight: 500;
		text-align: left;
	}
	.img_box{
		max-width: 100px;
		height: 100%;
		width: 100%;
		background-color: #ffffff;
		display: flex;
		align-items: center;
		font-size: 22px /* 22.5/73.6458 */;
		overflow: hidden;
		justify-content: center;
		border-radius: 8px;
	}
	.loading{
		width: 60px;
	}
	.dotting {
		margin-top: 4px;
		margin-left: 5px;
		display: block; width: 2px; height: 2px;
		box-shadow: 2px 0 currentColor, 6px 0 currentColor, 10px 0 currentColor; /* for IE9+, ..., 3个点 */
		animation: dot 1s infinite step-start both; /* for IE10+, ... */
		*zoom: expression(this.innerHTML = '...'); /*  for IE7. 若无需兼容IE7, 此行删除 */
	}
	.dotting:before { content: '...'; } /* for IE8. 若无需兼容IE8, 此行以及下一行删除*/
	.dotting::before { content: ''; } /* for IE9+ 覆盖 IE8 */
	:root .dotting { margin-right: 18px; } /* for IE9+,FF,CH,OP,SF 占据空间*/
	@keyframes dot {
		25% { box-shadow: none; }                                  /* 0个点 */
		50% { box-shadow: 2px 0 currentColor; }                    /* 1个点 */
		75% { box-shadow: 2px 0 currentColor, 6px 0 currentColor;  /* 2个点 */ }
	}
</style>
